import { Home, Plus } from "lucide-react";
import { useState } from "react";

type TodoInputProps = {
  onAdd: (title: string) => void;
  isPending: boolean;
  onHome?: () => void;
};

export const TodoInput = ({ onAdd, isPending, onHome }: TodoInputProps) => {
  const [title, setTitle] = useState("");

  const handleSubmit = () => {
    const trimmed = title.trim();
    if (!trimmed) return;
    onAdd(trimmed);
    setTitle("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="flex items-center gap-3">
      {onHome && (
        <button
          type="button"
          onClick={onHome}
          className="flex h-10 w-10 shrink-0 items-center justify-center text-primary"
          aria-label="ホーム"
        >
          <Home className="h-6 w-6" />
        </button>
      )}
      <div className="flex flex-1 items-center gap-2 rounded-full border border-border bg-muted/50 px-4 py-3">
        <input
          type="text"
          className="flex-1 bg-transparent text-base text-foreground placeholder:text-muted-foreground outline-none"
          placeholder="追加..."
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isPending}
        />
        <button
          type="button"
          onClick={handleSubmit}
          disabled={isPending || !title.trim()}
          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground disabled:opacity-50"
          aria-label="追加"
        >
          <Plus className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
